const BLSValidationWorker = {
  create: () => new Worker(new URL('./index.js', import.meta.url)),
}

export { BLSValidationWorker }
